import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDocuments = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.7793 10.9844C8.19351 10.9844 8.5293 11.3202 8.5293 11.7344C8.52923 12.1485 8.19347 12.4844 7.7793 12.4844H6.25C5.83583 12.4844 5.50007 12.1485 5.5 11.7344C5.5 11.3202 5.83579 10.9844 6.25 10.9844H7.7793Z",
			fill: ""
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.75 7.61719C14.1642 7.61719 14.5 7.95297 14.5 8.36719C14.5 8.7814 14.1642 9.11719 13.75 9.11719H6.25C5.83579 9.11719 5.5 8.7814 5.5 8.36719C5.5 7.95297 5.83579 7.61719 6.25 7.61719H13.75Z",
			fill: ""
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.75 4.25C14.1642 4.25 14.5 4.58579 14.5 5C14.5 5.41421 14.1642 5.75 13.75 5.75H6.25C5.83579 5.75 5.5 5.41421 5.5 5C5.5 4.58579 5.83579 4.25 6.25 4.25H13.75Z",
			fill: ""
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M15.5 1C16.6046 1 17.5 1.89543 17.5 3V17C17.5 18.0357 16.7128 18.887 15.7041 18.9893L15.5 19H4.5L4.2959 18.9893C3.35435 18.8938 2.6062 18.1457 2.51074 17.2041L2.5 17V3C2.5 1.89543 3.39543 1 4.5 1H15.5ZM4.5 2.5C4.22386 2.5 4 2.72386 4 3V17C4 17.2761 4.22386 17.5 4.5 17.5H15.5C15.7761 17.5 16 17.2761 16 17V3C16 2.72386 15.7761 2.5 15.5 2.5H4.5Z",
			fill: ""
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.7793 10.9844C8.19351 10.9844 8.5293 11.3202 8.5293 11.7344C8.52923 12.1485 8.19347 12.4844 7.7793 12.4844H6.25C5.83583 12.4844 5.50007 12.1485 5.5 11.7344C5.5 11.3202 5.83579 10.9844 6.25 10.9844H7.7793Z",
			stroke: ""
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.75 7.61719C14.1642 7.61719 14.5 7.95297 14.5 8.36719C14.5 8.7814 14.1642 9.11719 13.75 9.11719H6.25C5.83579 9.11719 5.5 8.7814 5.5 8.36719C5.5 7.95297 5.83579 7.61719 6.25 7.61719H13.75Z",
			stroke: ""
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.75 4.25C14.1642 4.25 14.5 4.58579 14.5 5C14.5 5.41421 14.1642 5.75 13.75 5.75H6.25C5.83579 5.75 5.5 5.41421 5.5 5C5.5 4.58579 5.83579 4.25 6.25 4.25H13.75Z",
			stroke: ""
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M15.5 1C16.6046 1 17.5 1.89543 17.5 3V17C17.5 18.0357 16.7128 18.887 15.7041 18.9893L15.5 19H4.5L4.2959 18.9893C3.35435 18.8938 2.6062 18.1457 2.51074 17.2041L2.5 17V3C2.5 1.89543 3.39543 1 4.5 1H15.5ZM4.5 2.5C4.22386 2.5 4 2.72386 4 3V17C4 17.2761 4.22386 17.5 4.5 17.5H15.5C15.7761 17.5 16 17.2761 16 17V3C16 2.72386 15.7761 2.5 15.5 2.5H4.5Z",
			stroke: ""
		})
	]
});
export default SvgDocuments;
